import React from "react";
import {Layout} from "../Components/Layout";
import { AppProvider } from "./Provider";


export const  MirrorflyLayout = ()=>{
    return (
    <AppProvider>
        <Layout/>
    </AppProvider>
         );
   }


